// ** MUI Imports
import Typography from '@mui/material/Typography'
import { WidgetType } from 'src/lib/types/dashboardAnalytics'
import { CircularLoader } from '../../common/loader-components/Loader'
import { numberWithCommas, roundToDecimals } from 'src/lib/utils/helpers'
import { ArrowDownRight, ArrowUpRight, Minus } from 'react-feather'
import { secondsToDaysHoursMinutes } from 'src/lib/utils/helpers'

const AnalyticsDataWidget: React.FC<WidgetType> = ({
  title,
  value,
  description,
  valueType,
  isLoading,
  fontProperties,
  cardVariant = 'elevation',
  hideBorders = false,
  removeInnerPadding = false,
  customClass = '',
  compareToValue,
  moreIsGood,
  compareToFontProperties
}) => {
  const { fontWeight, lineHeight, fontSize, fontColor } = fontProperties || {}
  const {
    fontWeight: compareToFontWeight,
    lineHeight: compareToLineHeight,
    fontSize: compareToFontSize
  } = compareToFontProperties || {}
  const delta = (value / compareToValue) * 100
  const percentageDifference = roundToDecimals((delta - 100).toString(), 0)

  const isGood = moreIsGood ? Boolean(parseInt(percentageDifference) > 0) : Boolean(parseInt(percentageDifference) < 0)

  return (
    <div
      className={`w-full rounded-lg  border-[#F0F0F0] flex flex-col 
            ${cardVariant === 'elevation' ? 'shadow' : ''} ${hideBorders ? 'border-0' : 'border'} ${customClass}`}
    >
      {Boolean(title?.length) ? (
        <Typography sx={{ fontWeight: 500, color: 'text.header', fontSize: 14, lineHeight: '18px' }}>
          {title ?? ''}
        </Typography>
      ) : (
        <></>
      )}
      <div style={{ padding: removeInnerPadding ? '0rem' : '1rem 1rem 0rem' }}>
        {!Boolean(isLoading) ? (
          <div className='flex items-end gap-2'>
            <Typography
              sx={{
                fontWeight: fontWeight,
                fontSize: fontSize,
                lineHeight: lineHeight,
                fontColor: fontColor,
                display: 'flex',
                alignItems: 'end'
              }}
            >
              {valueType === 'percentage'
                ? `${value}%`
                : valueType === 'currency'
                ? `₹${isNaN(parseInt(value?.split('.')[0])) ? '00' : numberWithCommas(value?.split('.')[0], 2, false)}`
                : valueType === 'string'
                ? value
                : isNaN(parseInt(value))
                ? 0
                : valueType === 'time'
                ? `${
                    isNaN(parseInt(value?.split('.')[0]))
                      ? '00'
                      : `${secondsToDaysHoursMinutes(parseInt(value?.split('.')[0]))}`
                  }`
                : numberWithCommas(value, 2, false)}
              {valueType === 'currency' ? (
                <span style={{ fontSize: fontSize, fontWeight: 400, lineHeight: lineHeight }}>
                  .{isNaN(parseInt(value?.split('.')[1])) ? '00' : value?.split('.')[1].substring(0, 2)}
                </span>
              ) : (
                <></>
              )}
            </Typography>
            {compareToValue ? (
              <p
                style={{
                  display: 'flex',
                  justifyContent: 'start',
                  alignItems: 'center',
                  margin: 0,
                  gap: 2,
                  fontSize: compareToFontSize,
                  lineHeight: compareToLineHeight,
                  fontWeight: compareToFontWeight,
                  color: isGood ? '#2C874A' : '#CB2711'
                }}
              >
                {Boolean(percentageDifference) &&
                percentageDifference !== 'Infinity' &&
                !isNaN(Number(percentageDifference)) ? (
                  isGood ? (
                    <ArrowUpRight className='h-4 w-4 stroke-[2.5px]' />
                  ) : (
                    <ArrowDownRight className='h-4 w-4 stroke-[2.5px]' />
                  )
                ) : (
                  <></>
                )}
                {Boolean(percentageDifference) &&
                percentageDifference !== 'Infinity' &&
                !isNaN(Number(percentageDifference)) ? (
                  `${Math.abs(Number(percentageDifference))}%`
                ) : (
                  <Minus className='text-[#949494] w-[14px] h-[14px] stroke-[2.5px]' />
                )}
              </p>
            ) : (
              <></>
            )}
          </div>
        ) : (
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <CircularLoader />
          </div>
        )}
      </div>
      {Boolean(description?.length) ? (
        <Typography
          variant='body2'
          sx={{
            padding: removeInnerPadding ? '0rem' : '0rem 1rem 1rem',
            color: '#949494',
            lineHeight: '16px',
            fontSize: '14px'
          }}
        >
          {description}
        </Typography>
      ) : (
        <></>
      )}
    </div>
  )
}

export default AnalyticsDataWidget
